var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDangerCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Danger Circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Light-Outline/Danger-Circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Danger-Circle"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 11",
    cx: 7.66463,
    cy: 7.665,
    r: 6.665,
    fill: "#2DB29E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66598 14.3335C3.98998 14.3335 0.99931 11.3428 0.99931 7.66683C0.99931 3.99083 3.98998 1.00016 7.66598 1.00016C11.342 1.00016 14.3326 3.99083 14.3326 7.66683C14.3326 11.3428 11.342 14.3335 7.66598 14.3335ZM7.66598 13.3335C10.7906 13.3335 13.3326 10.7915 13.3326 7.66683C13.3326 4.54216 10.7906 2.00016 7.66598 2.00016C4.54131 2.00016 1.99931 4.54216 1.99931 7.66683C1.99931 10.7915 4.54131 13.3335 7.66598 13.3335ZM7.66338 5.8029C7.29471 5.8029 6.99671 5.5049 6.99671 5.13623C6.99671 4.76756 7.29471 4.46956 7.66338 4.46956C8.03204 4.46956 8.33338 4.76756 8.33338 5.13623C8.33338 5.5049 8.03804 5.8029 7.67004 5.8029L7.66338 5.8029ZM7.66991 10.6975C7.39391 10.6975 7.16991 10.4735 7.16991 10.1975L7.16991 7.2515C7.16991 6.9755 7.39391 6.7515 7.66991 6.7515C7.94591 6.7515 8.16991 6.9755 8.16991 7.2515L8.16991 10.1975C8.16991 10.4735 7.94591 10.6975 7.66991 10.6975Z",
    fill: "white"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerCircle);
export default __webpack_public_path__ + "static/media/DangerCircle.dc243a9c65345585d544b7b50c8ff9ae.svg";
export { ForwardRef as ReactComponent };